module.exports = __webpack_public_path__ + "static/img/jinru.182fcc70.svg";